import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    id: "app",
    class: "header-article__container"
};
const _hoisted_2 = {
    class: "magnetograms-tracker__form",
    action: "",
    method: "",
    "data-css": "c-form",
    onsubmit: "return false;"
};
const _hoisted_3 = { class: "magnetograms-tracker__select_area" };
const _hoisted_4 = { class: "magnetograms-tracker__select form__select-free view_year" };
const _hoisted_5 = { class: "form__label-wrapper" };
const _hoisted_6 = {
    for: "",
    class: "form__select-free-label"
};
const _hoisted_7 = { class: "form__select-free-wrapper" };
const _hoisted_8 = ["value"];
const _hoisted_9 = {
    key: 0,
    class: "magnetograms-tracker__select form__select-free view_month"
};
const _hoisted_10 = { class: "form__label-wrapper" };
const _hoisted_11 = {
    for: "",
    class: "form__select-free-label"
};
const _hoisted_12 = { class: "form__select-free-wrapper" };
const _hoisted_13 = ["value"];
const _hoisted_14 = {
    key: 1,
    class: "magnetograms-tracker__select form__select-free view_day"
};
const _hoisted_15 = { class: "form__label-wrapper" };
const _hoisted_16 = {
    for: "",
    class: "form__select-free-label"
};
const _hoisted_17 = { class: "form__select-free-wrapper" };
const _hoisted_18 = ["value"];
const _hoisted_19 = { class: "magnetograms-tracker__controls" };
const _hoisted_20 = { class: "form__submit-text" };
const _hoisted_21 = { class: "form__submit-text" };
const _hoisted_22 = { class: "form__submit-text" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = ["src"];
const _hoisted_26 = { key: 1 };
import { useMagnetogramViewer } from './features/useMagnetogramViewer';
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const { selectedDay, selectedMonth, selectedYear, onDropdownChange, months, days, years, view, prevDate, nextDate, nowDate, labelSelectYear, labelSelectMonth, labelSelectDay, labelButtonNow, labelButtonPrevious, labelButtonNext, textNoImagesAvailable, imageUrls } = useMagnetogramViewer();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("form", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createCommentVNode(" Year "),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(labelSelectYear)), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("select", {
                                    name: "select-years",
                                    class: "form__select-free-el",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(selectedYear) ? (selectedYear).value = $event : null)),
                                    onChange: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_unref(onDropdownChange) && _unref(onDropdownChange)(...args))),
                                    id: "magnetograms-tracker1",
                                    "data-placeholder": "Bitte Wählen"
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(years), (year) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: year,
                                            value: year
                                        }, _toDisplayString(year), 9 /* TEXT, PROPS */, _hoisted_8));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                    [_vModelSelect, _unref(selectedYear)]
                                ])
                            ])
                        ]),
                        _createCommentVNode(" Month "),
                        (_unref(view) === 'datenDay' || _unref(view) === 'datenMonth')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(labelSelectMonth)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _withDirectives(_createElementVNode("select", {
                                        name: "select-months",
                                        class: "form__select-free-el",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(selectedMonth) ? (selectedMonth).value = $event : null)),
                                        onChange: _cache[3] || (_cache[3] =
                                            //@ts-ignore
                                            (...args) => (_unref(onDropdownChange) && _unref(onDropdownChange)(...args))),
                                        "data-placeholder": "Bitte Wählen"
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(months), (month) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: month,
                                                value: month
                                            }, _toDisplayString(month), 9 /* TEXT, PROPS */, _hoisted_13));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                        [_vModelSelect, _unref(selectedMonth)]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Day "),
                        (_unref(view) === 'datenDay')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(labelSelectDay)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _withDirectives(_createElementVNode("select", {
                                        class: "form__select-free-el",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(selectedDay) ? (selectedDay).value = $event : null)),
                                        onChange: _cache[5] || (_cache[5] =
                                            //@ts-ignore
                                            (...args) => (_unref(onDropdownChange) && _unref(onDropdownChange)(...args))),
                                        "data-placeholder": "Bitte Wählen",
                                        name: ""
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(days), (day) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: day,
                                                value: day
                                            }, _toDisplayString(day), 9 /* TEXT, PROPS */, _hoisted_18));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                        [_vModelSelect, _unref(selectedDay)]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode("- Button Navigation "),
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                            onClick: _cache[6] || (_cache[6] =
                                //@ts-ignore
                                (...args) => (_unref(prevDate) && _unref(prevDate)(...args))),
                            type: "button",
                            class: "form__submit"
                        }, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(labelButtonPrevious)), 1 /* TEXT */)
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => (_unref(nowDate) && _unref(nowDate)(...args))),
                            type: "button",
                            class: "form__submit"
                        }, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(labelButtonNow)), 1 /* TEXT */)
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[8] || (_cache[8] =
                                //@ts-ignore
                                (...args) => (_unref(nextDate) && _unref(nextDate)(...args))),
                            type: "button",
                            class: "form__submit"
                        }, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(labelButtonNext)), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _createCommentVNode(" Images "),
                (_unref(imageUrls)[0].value !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imageUrls), (url, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (url.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        _createElementVNode("img", {
                                            src: url.value,
                                            alt: "Geomagnetism Image"
                                        }, null, 8 /* PROPS */, _hoisted_25)
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("p", null, _toDisplayString(_unref(textNoImagesAvailable)), 1 /* TEXT */)
                    ]))
            ]));
        };
    }
});
